export default {

  defaultQuery: {
    categories: 'all',
    aggregateUrls: true
  },

  sumColumns: ['Clicks', 'Impressions', 'Cost', 'Conversions', 'ConversionValue'],

  titleColumns: ['Headline', 'HeadlinePart1', 'HeadlinePart2', 'HeadlinePart3'],
  text1Columns: ['Description', 'Description1'],
  text2Columns: ['Description2'],
  urlColumns: ['CreativeFinalUrls', 'CreativeDestinationUrl'],
  aggregateColumns:  ['Headline', 'HeadlinePart1', 'HeadlinePart2', 'HeadlinePart3',
              'Description', 'Description1', 'Description2'],

}



// WEBPACK FOOTER //
// ./src/config/logic/ads.js